const ERRORS = {
    ERROR_REQUIRED: 'This field is required',
    ERROR_VALID_EMAIL: 'Add a valid email',
    ERROR_PASSWORD_LENGTH: 'Passwords must have at least 8 characters',
    ERROR_NAME_ENUM: 'Add a valid name'
  }
  
  export default ERRORS